export default __webpack_public_path__ + "static/media/rejectedCommentIcon.bb29f03a.svg";